"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlMapper = void 0;
const i18n_1 = require("../i18n");
/**
  Maps locale to storefront fully qualified domain name
  @returns {string} structure example: https://storefront.qa.aws.clarks.com/en-gb or https://storefront.qa.aws.clarksoutlet.co.uk
*/
function urlMapper(locale, config) {
    const localeToUrlMap = {
        'en-gb': config.getRequired('STOREFRONT_FQDN'),
        'en-ie': config.getRequired('STOREFRONT_FQDN'),
        'en-us': config.getRequired('STOREFRONT_FQDN'),
        'en-ca': config.getRequired('STOREFRONT_FQDN'),
        'fr-ca': config.getRequired('STOREFRONT_FQDN'),
        'en-vg': config.getRequired('OUTLET_STOREFRONT_FQDN'),
        'en-gb-outlet': config.getRequired('OUTLET_STOREFRONT_FQDN'),
    };
    const lowerLocale = locale.toLowerCase();
    const url = localeToUrlMap[lowerLocale];
    if (i18n_1.outletLocales.includes(lowerLocale))
        return url;
    return `${url}/${lowerLocale}`;
}
exports.urlMapper = urlMapper;
//# sourceMappingURL=index.js.map